
export default {
  inject: ['Breadcrumb'],

  data() {
    return {
      separator: '',
    };
  },

  mounted() {
    this.separator = this.Breadcrumb.separator;
  },
};
